import { a as M } from "../add-DH4DZT_w.mjs";
import { f as _ } from "../format-DF9p-6BI.mjs";
import { determineSeriesPrefix as w } from "./program-helpers.js";
import { g as k } from "../index-0wieGV50.mjs";
const D = /* @__PURE__ */ new Date(), T = /* @__PURE__ */ new Map([
  ["series", "Episode"],
  ["movies", "Film"],
  ["films", "Film"],
  ["all", "All"]
]), A = async ({ startDateTime: i, offset: o, type: c, SCHEDULE_ENDPOINT: l, NETWORK: f }) => {
  const d = _(i, "yyyy-MM-dd"), u = _(M(i, { days: 60 }), "yyyy-MM-dd"), r = `${l}/${f}?ordering=start_ts_parse&&start_date__range=${d},${u}&limit=100&offset=${o}&program_class__iexact=${T.get(c)}`;
  try {
    const e = await fetch(r);
    return e != null && e.ok ? await e.json() : (console.log(`An error was returned from fetch. HTTP Response Code: ', ${e == null ? void 0 : e.status}`), null);
  } catch (e) {
    return console.log("Fetch failed with error:", e), null;
  }
}, b = async ({
  numberOfPrograms: i = 4,
  startTime: o = "11:00",
  endTime: c = "23:00",
  type: l = "series",
  canUseSameDay: f = !1,
  SCHEDULE_ENDPOINT: d,
  NETWORK: u
}) => {
  let r = [], e = [], n = [], g = "", p = 0;
  do {
    const m = await A({
      startDateTime: D,
      offset: p,
      type: l,
      SCHEDULE_ENDPOINT: d,
      NETWORK: u
    });
    if (m !== null) {
      const s = m.results.filter((t) => t.start_ts_parse * 1e3 > D.valueOf());
      g = m.next;
      for (let t = 0; t < s.length; ++t) {
        const h = s[t].start_ts_parse * 1e3, a = _(new Date(h), "yyyy-MM-dd");
        if (!f && n.includes(a)) continue;
        const y = k("America/New_York", /* @__PURE__ */ new Date(`${a}T${o}`)) / 36e5, x = (/* @__PURE__ */ new Date(`${a}T${o}:00-0${y * -1}:00`)).valueOf(), S = (/* @__PURE__ */ new Date(`${a}T${c}:00-0${y * -1}:00`)).valueOf();
        if (h >= x && h <= S)
          switch (T.get(l)) {
            case "Episode": {
              let $ = w(s[t].series_prefix);
              e.includes($) || (r.push(s[t]), e.push($), n.push(a));
              break;
            }
            case "Film":
              e.includes(s[t].title_code) || (r.push(s[t]), e.push(s[t].title_code), n.push(a));
              break;
            case "All":
              !e.includes(s[t].title_code) && !e.includes(w(s[t].series_prefix)) && (r.push(s[t]), e.push(s[t].series_prefix ?? s[t].title_code), n.push(a));
              break;
          }
        if (r.length >= i) break;
      }
    }
    p = p + 100;
  } while (r.length < i && g !== null);
  return r;
};
export {
  b as getFeaturedList
};
